import { mustBeTrue } from '../../libs/validators';

export const inputAcceptTransmitDataConfig = {
  label:
    'Vous acceptez de transmettre ces données à FranceConnect pour traiter votre demande d’aide.',
  name: 'acceptTransmitData',
  validators: {
    format: [],
    submit: mustBeTrue('Veuillez cocher cette case si vous souhaitez continuer'),
  },
};
